<template>
  <div class="animated fadeIn">
    <b-card>
      <b-row>
        <b-col class="page-title">
          WSFinder
        </b-col>
      </b-row>

      <b-row v-if="!is_main">
        <b-col sm="6">
          <select v-model="limit" @change="$refs._list.refresh()">
            <option disabled value="20">Please select display count : Default 20</option>
            <option value="10">10</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='agent.name';so.skt='name'">name</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='agent.host';so.skt='host'">host</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input v-model="so.sv" @keyup.enter="refresh()"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <!-- <b-btn variant="outline-secondary"><i :class="'fa ' + (so.adv ? 'fa-search-minus' : 'fa-search-plus')"></i></b-btn> -->
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>

      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found" class="table-responsive table_add" :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="agent" slot-scope="row">
          {{row.item.agent.name}}
          <span v-if="row.item.agent.name != row.item.agent.host">[ {{row.item.agent.host}} ]</span>
        </template>
        <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime}}</template>
        <template slot="action" slot-scope="row">{{codes.agent_forgery[row.item.action] || row.item.action}}</template>
        <template slot="target" slot-scope="row">
          <span v-if="row.item.type.toUpperCase() == 'WMDS'">{{row.item.target}}</span>
          <span v-else-if="row.item.target_type">
              [{{row.item.target_type}}]
              <span v-if="row.item.action.toUpperCase() == 'RENAME' && row.item.old_path">
                {{row.item.old_path}} {{ row.item.old_hash ? `[${row.item.old_hash}]` : '' }}  ->
              </span>
              <span v-if="row.item.action.toUpperCase() == 'MOVE' && row.item.old_path">
                {{row.item.old_path}} {{ row.item.old_hash ? `[${row.item.old_hash}]` : '' }}  ->
              </span>
            <span v-else>
              {{ row.item.action.toUpperCase() == 'MODIFIED HASH' && row.item.old_path ? `${row.item.old_path} [${row.item.old_hash}] ->` : '' }}
            </span>
            {{row.item.path}} {{row.item.hash ? `[${row.item.hash}]` : ''}}
          </span>
          <span v-else>
            {{row.item.target ? row.item.target : row.item.path }}
          </span>
        </template>
        <!-- <template slot="now_snapshot" slot-scope="row">{{JSON.parse(row.item.now_snapshot).watching}}</template> -->
      </b-table>
      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm"  align="center" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" />
        </b-col>
      </b-row>
    </b-card>
    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
